/**
 * Dialog utility to enable more accessible and feature-rich dialogs.
 * This class is a work in progress.
 */
class Dialog {
    constructor(element, options = {}) {
        this.el = element;

        this.options = {
            backdropClose: true,
            ...options,
        };
        this.name = this.el.getAttribute("data-dialog");
        this.type = this.el.dataset.dialogType;
        this.dialogOpenElements = document.querySelectorAll(
            "[data-dialog-open='" + this.name + "']",
        );
        this.dialogCloseElements = document.querySelectorAll(
            "[data-dialog-close='" + this.name + "']",
        );
        this.dialogCloseElements = Array.from(this.dialogCloseElements).concat(
            Array.from(this.el.querySelectorAll("[data-dialog-close]")),
        );

        this.contentSlot = this.el.querySelector("[data-dialog-content]");
        this.content = document.getElementById(this.el.dataset.dialogContentId);

        this.init();
    }

    init() {
        this.dialogOpenElements.forEach((element) => {
            element.addEventListener("click", (e) => {
                if (element.dataset.dialogContentTemplate) {
                    this.content = document.querySelector(
                        `[data-dialog-content='${element.dataset.dialogContentTemplate}']`,
                    );
                }

                this.open(e);
            });
        });

        this.dialogCloseElements.forEach((element) => {
            element.addEventListener("click", (e) => {
                this.close(e);
            });
        });

        // Optionally close dialog when clicking on backdrop
        this.el.addEventListener("click", (e) => {
            if (this.options.backdropClose && e.target === this.el) {
                this.close(e);
            }
        });

        // Handle the 'close' event
        this.el.addEventListener("close", () => {
            this.onClose();
        });

        this.setScrollbarWidth();
    }

    open(e) {
        this.fixBody();

        this.el.showModal();

        document.body.classList.add("dialog-is-open");
        document.body.classList.add(`${this.name}-dialog-is-open`);

        this.el.setAttribute("aria-hidden", "false");

        // If a content is specified, inject the content into the dialog's slot
        if (this.contentSlot && this.content) {
            this.contentSlot.innerHTML = this.content.innerHTML;
        }

        // If a dialog type has been set, add it as a data attribute
        if (this.type) {
            this.el.setAttribute("data-type", type);
        }
    }

    close(e) {
        this.el.close();
    }

    onClose() {
        this.unfixBody();

        document.body.classList.remove("dialog-is-open");
        document.body.classList.remove(`${this.name}-dialog-is-open`);

        this.el.setAttribute("aria-hidden", "true");
        this.el.setAttribute("data-type", "");

        // TODO - find a way to remove content from slot *after* fade out
        // if (this.contentSlot) {
        //     this.contentSlot.innerHTML = "";
        // }
    }

    fixBody() {
        document.documentElement.classList.add("no-scroll");
    }

    unfixBody() {
        document.documentElement.classList.remove("no-scroll");
    }

    setScrollbarWidth() {
        // Use this to stop elements jumping when dialog is opened
        document.documentElement.style.setProperty(
            "--scrollbar-width",
            window.innerWidth - document.documentElement.clientWidth + "px",
        );
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const dialogElements = document.querySelectorAll("[data-dialog]");

    dialogElements.forEach((element) => {
        new Dialog(element);
    });
});
